import { lazy, Suspense, useEffect, useState } from 'react';
import { useAuth } from './contexts/AuthContext';
import LoadingSpinner from './components/LoadingSpinner';
import LandingPage from './components/LandingPage/LandingPage';
import './App.css';

// Preload the ChatApp component
const ChatApp = lazy(() => {
  // Start loading immediately
  const preloadPromise = import('./components/ChatApp/ChatApp');
  return preloadPromise;
});

function App() {
  const { currentUser, loading } = useAuth();
  const [showSpinner, setShowSpinner] = useState(true);

  // Hide spinner after a short delay to prevent flash
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinner(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  // Show minimal loading spinner for very quick loads
  if (loading && showSpinner) {
    return <LoadingSpinner />;
  }

  // Show landing page if not authenticated
  if (!currentUser) {
    return <LandingPage />;
  }

  // Show chat app only when authenticated
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <ChatApp />
    </Suspense>
  );
}

export default App;